<div class="pag-container">

  <!-- breadcrumbs -->
  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink="">
  </app-campaign-3-breadcrumb>

  <!-- buttons -->
  <div class="ui-g-12 vertical-margin-20">
    <div class="ui-g-6 no-lateral-padding">
      <h1 class="title">{{ 'challenge.giftCreation' | translate }}</h1>
    </div>

    <div class="ui-g-6 d-flex justify-content-end">
      <button class="btn-page-act" style="margin-right: 10px;" (click)="onBackAction()">
        <i class="pi pi-arrow-left margin-fit"></i>
        <span>{{ 'challenge.back' | translate }}</span>
      </button>
 <button class="btn-page-act" 
  [disabled]="!canSave || readOnly || hasExpiredAccumulators" 
  [ngClass]="{'disabled': readOnly || hasExpiredAccumulators}" 
  (click)="onSaveGifts()">
  <i class="pi pi-save margin-fit"></i>
  <span>{{ 'challenge.save' | translate }}</span>
</button>
    </div>
  </div>

  <div class=" ui-g-12 button-container">
    <button type="button" class="btn-form-act" (click)="aggiungiPremio('accumulatore')"
     [disabled]="readOnly"  [ngClass]="{'disabled': readOnly}">
      <i class="pi pi-plus-circle"></i> <span>{{ 'challenge.add_gift_acc_type' | translate }}</span>
    </button>

    <button type="button" class="btn-form-act" (click)="aggiungiPremio('cluster')"
     [disabled]="readOnly"  [ngClass]="{'disabled': readOnly}">
      <i class="pi pi-plus-circle"></i> <span>{{ 'challenge.add_gift_clust_type' | translate }}</span>
    </button>
  </div>

  <hr>

  <div *ngIf="premiList && premiList.length > 0; else emptyPremi" style="margin-top:1px; padding-top: 1px; border-top:1px solid transparent;">
    <div *ngFor="let premio of premiList; let i = index" class="form-block">

      <!-- HEADER -->
      <div class="form-block-header">
        <span>Premi {{ i + 1 }}</span>
        <button type="button" class="btn-remove" (click)="rimuoviPremio(i)">✕</button>
      </div>

      <!-- BODY -->
      <div class="form-block-body">
        
        <!-- RIGA 1 -->
        <div class="ui-g">
          <div class="ui-g-6">
            <app-form-fields
              [attr.data-testid]="'premioDescription-' + i"
              #premioDescription
              [(fieldModel)]="premio.description"
              [type]="'string'"
              [label]="'challenge.description' | translate"
              [name]="'description' + i"
              [placeholder]="'challenge.enter_description' | translate"
              [required]="true"
              [disabled]="readOnly">
            </app-form-fields>
          </div>

          <div class="ui-g-6">
            <app-form-fields
              [attr.data-testid]="'premioTipologia-' + i"
              #premioTipologia
              [(fieldModel)]="premio.tipologia"
              [type]="'dropdown'"
              [label]="'challenge.tipologia' | translate"
              [name]="'tipologia' + i"
              [options]="tipologiePremio"
              [optionLabel]="'label'"
              [required]="true"
              [disabled]="true">
            </app-form-fields>
          </div>
        </div>

<!-- RIGA 2 -->
<div class="ui-g" *ngIf="premio.tipoForm === 'accumulatore'">
  <div class="ui-g-6 accumulator-grid">
    <button class="btn-page-plus" (click)="onAddAccumulator(i)" aria-label="Aggiungi accumulatore"
      title="'challenge.add_accumulator' | translate">
      <i class="pi pi-plus margin-fit"></i>
    </button>

    <div>
      <app-form-fields
        [attr.data-testid]="'premioAccumulatore-' + i"
        #premioAccumulatore
        [(fieldModel)]="premio.accumulatore.description"
        [type]="'string'"
        [label]="'challenge.accumulatore' | translate"
        [name]="'accumulatore' + i"
        [required]="true"
        [placeholder]="'challenge.select_acm' | translate"
        [disabled]="true">
      </app-form-fields>

      <small *ngIf="premio.accumulatore.expired" style="color: #e74c3c; display: block; margin-top: 2px;">
        {{ 'challenge.accumulator_expired_warning' | translate }}
      </small>
    </div>

  </div>


          <div class="ui-g-6">
            <div *ngIf="true">
            <app-form-fields 
              [attr.data-testid]="'premioCausale-' + i"
              #premioCausale
              [(fieldModel)]="premio.causale"
              [type]="'dropdown'"
              [label]="'challenge.causale' | translate"
              [name]="'causale' + i"
              [options]="premio.causali"
              [optionLabel]="'label'"
              [required]="true"
              [disabled]="premio.reasonDisabled || readOnly"
              [placeholder]="'challenge.select_reason' | translate">
            </app-form-fields>
            </div>
            
          </div>
        </div>

        <!-- Variante cluster -->
        <div class="ui-g" *ngIf="premio.tipoForm === 'cluster'">
          <div class="ui-g-6">
            <app-form-fields
              [attr.data-testid]="'premioCluster-' + i"
              #premioCluster
              [filterable]="true"
              [(fieldModel)]="premio.cluster"
              [placeholder]="'challenge.select_cluster' | translate"
              [type]="'dropdown'"
              [label]="'challenge.cluster' | translate"
              [name]="'cluster' + i"
              [options]="clusterList"
              [optionLabel]="'label'"
              [required]="true"
              [disabled]="readOnly">
            </app-form-fields>
          </div>
      

          <div class="ui-g-4">
            <app-form-fields
              [attr.data-testid]="'premioClusterDateEndType-' + i"
              #premioClusterDateEndType
              [(fieldModel)]="premio.cluster_date_end_type"
              [options]="clusterDateEndTypeOptions"
              [optionLabel]="'label'"
              [type]="'dropdown'"
              [placeholder]="'challenge.select_cluster_date_end_type' | translate"
              [label]="'challenge.cluster_date_end_type' | translate"
              [name]="'clusterDateEndType' + i"
              [required]="true"
              [disabled]="readOnly">
            </app-form-fields>
          </div>
        </div>
       

        

        <!-- RIGA 3 -->
        <div class="ui-g">
          <div class="ui-g-6" *ngIf="premio.tipoForm === 'accumulatore'">
            <app-form-fields
              [attr.data-testid]="'premioValore-' + i"
              #premioValore
              [(fieldModel)]="premio.valore"
              [type]="'number'"
              [label]="'challenge.valore' | translate"
              [name]="'valore' + i"
              [required]="true"
              [disabled]="readOnly"
              [placeholder]="'challenge.insert_value' | translate"
               >
            </app-form-fields>
          </div>

          <div class="ui-g-6" *ngIf="premio.tipoForm === 'cluster'">
            <app-form-fields
              [attr.data-testid]="'premioOperazione-' + i"
              #premioOperazione
              [(fieldModel)]="premio.operazione"
              [placeholder]="'challenge.select_operation' | translate"
              [type]="'dropdown'"
              [label]="'challenge.operazione' | translate"
              [name]="'operazione' + i"
              [options]="operazioni"
              [optionLabel]="'label'"
              [required]="true"
               [disabled]="readOnly">
            </app-form-fields>
          </div>
           <div class="ui-g-3" *ngIf="premio.cluster_date_end_type?.value === 'S'">
           <app-form-fields
              [attr.data-testid]="'premioClusterDateEnd-' + i"
              #premioClusterDateEnd
              [(fieldModel)]="premio.cluster_date_end"
              [type]="'date'"
              [placeholder]="'challenge.select_cluster_date_end' | translate"
              [label]="'challenge.cluster_date_end' | translate"
              [name]="'clusterDateEnd' + i"
              [required]="true"
              [disabled]="readOnly"
              [minDate]="today"
              [maxDate]="getClusterMaxDate(premio.cluster)">
            </app-form-fields>
        </div>
        </div>

      </div>
    </div>
  </div>
<ng-template #emptyPremi>
  <div class="empty-message">
    {{ 'challenge.emptyGifts' | translate }}
  </div>
</ng-template>


<!-- modale per gli acm -->
<p-dialog *ngIf="show.modalAcmList" [width]="1500" [height]="800" [(visible)]="show.modalAcmList" [responsive]="true"
  [header]="'challenge.search_accumulators' | translate " showEffect="fade" [modal]="true">

  <app-campaign-3-search-accumulators #searchAccumulators [accumulatorList]="listAccumulator"
    [multipleselection]="false" (acmSelected)="onAcmSelected($event)"></app-campaign-3-search-accumulators>


</p-dialog>


</div>



// WEBPACK FOOTER //
// ./src/app/views/challenge/gifts/gifts-edit-create.component.html